import { Component, signal, ChangeDetectionStrategy, inject } from '@angular/core';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { Icons } from '../../../../util/Icons';
import { SnackbarService } from '../../../../services/snackbar.service';
import { MatDialog } from '@angular/material/dialog';
import { LayoutService } from '../../../../../@vex/services/layout.service';
import { IconTesterComponent } from '../../../util/icon-tester/icon-tester.component';
import { MatButton } from '@angular/material/button';

@Component({
	selector: 'ara-frontend-tools',
	templateUrl: './frontend-tools.component.html',
	styleUrl: './frontend-tools.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [TranslocoDirective, MatButton],
})
export class FrontendToolsComponent {
	translocoService = inject(TranslocoService);
	icons = inject(Icons);
	private snackbar = inject(SnackbarService);
	dialog = inject(MatDialog);
	private layoutService = inject(LayoutService);

	isMobile = signal(false);

	constructor() {
		this.isMobile.set(this.layoutService.isMobile());
	}

	public openIconTester() {
		const dialogRef = this.dialog.open(IconTesterComponent, {
			height: '400px',
			width: '900px',
		});
		dialogRef.afterClosed().subscribe(() => {});
	}

	public showSuccessSnackbar() {
		this.snackbar.success('Success', 60000);
	}

	public showErrorSnackbar() {
		this.snackbar.error('Error', 60000);
	}

	public showWarnSnackbar() {
		this.snackbar.warn('Warn', 60000);
	}
}
